export const NavigationConstants = {
    SKR: '/skeepers-rewards',
    DFRACT: '/dfract',
    TOOLS: '/tools',
};
